module.exports = __webpack_public_path__ + "media/images/avatar-c1cb1038.png";